
import { Vue } from "vue-class-component";

export default class Main extends Vue {

}
